import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import './Meta.css';

function Meta() {
  const [imgUrl, setImgUrl] = useState('/ratio_26_05_07.png');

  useEffect(() => {
    getDoc(doc(db, 'config', 'images')).then((snap) => {
      if (snap.exists() && snap.data().metaMatchups) {
        setImgUrl(snap.data().metaMatchups);
      }
    });
  }, []);

  return (
    <div className="Meta">
      <Navbar />
      <main className="meta-main">
        <h1>Meta</h1>
        <p className="meta-subtitle">Tabla de enfrentamientos entre razas</p>
        <div className="meta-image-wrap">
          <img src={imgUrl} alt="Tabla de matchups" className="meta-image" />
          <p className="meta-image-date">Mayo 2026</p>
        </div>

        <div className="meta-guide">
          <h2 className="meta-guide-title">¿Cómo leer los matchups para una raza?</h2>
          <p>
            A continuación, mostramos un ejemplo de cómo interpretar los matchups para la raza <strong>Dragón</strong>:
          </p>
          <div className="meta-example-image-wrap">
            <img src="/ejemplo_dragon.png" alt="Ejemplo matchups Dragón" className="meta-example-image" />
          </div>
          <p>
            Para leer los matchups escoge una raza y léela de izquierda a derecha.
          </p>
          <ul className="meta-guide-list">
            <li>
              Contra <strong>Caballero</strong>, el color <span className="meta-tag beige">beige</span> indica que el matchup es <strong>"Neutro"</strong>. Lo mismo ocurre con el matchup Dragón vs <strong>Héroe</strong>.
            </li>
            <li>
              Contra <strong>Faerie</strong>, el color <span className="meta-tag verde">verde</span> muestra que Dragón tiene un matchup <strong>"Favorable"</strong>.
            </li>
            <li>
              Finalmente, contra <strong>Olímpico</strong> y <strong>Titán</strong>, el color <span className="meta-tag rosado">rosado</span> señala que Dragón enfrenta un matchup <strong>"Levemente Desfavorable"</strong>.
            </li>
          </ul>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Meta;
